export default "__VITE_ASSET__364ce3c9__"